import styled from 'styled-components';

export const TableWrapper = styled.div`
  margin-bottom: ${(props) => (props.isPaginated ? '20px' : '10px')};
`;
